// extracted by mini-css-extract-plugin
export default {"stores":"qi1AJ","stores__icon":"WnAaD","stores__icon-img":"btbJi","stores__icon-img-full":"zRfeB","stores__icon-full-width":"qtfYG"};